import useSWR from 'swr'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { FormattedMessage } from 'react-intl'
import { Content, Header, Main, Aside } from 'components/page'
import { Page } from 'layouts/pages'
import Sidebar from 'layouts/weather/forecast/Sidebar'
import Forecast from 'layouts/weather/forecast'
import Footer from 'layouts/weather/forecast/Footer'
import * as Weather from '@avcan/prismic/clients/weather'
import * as Context from 'layouts/weather/forecast/context'
import { Provider as LoopProvider } from 'services/msc/loop/metadata/context'

export async function getStaticProps({ locale }) {
    const date = new Date()
    const [forecast, tutorial] = await Promise.all([
        Weather.getForecast(date, locale),
        Weather.getTutorial('weather', locale),
    ])

    return {
        props: {
            forecast: forecast || null,
            tutorial: tutorial.data.tutorial,
        },
        revalidate: 300, // in seconds, 5 minutes!
    }
}

export default function WeatherForecast({ forecast, tutorial }) {
    const { locale } = useRouter()
    const { data } = useSWR([locale, 'weather/forecast'], fetcher, {
        revalidateOnMount: true,
        fallbackData: forecast,
    })

    return (
        <Context.Provider forecast={data?.data || null} tutorial={tutorial}>
            <Forecast />
        </Context.Provider>
    )
}

WeatherForecast.getLayout = getLayout

export function getLayout(children) {
    const title = (
        <Link href="/weather/forecast">
            <a>
                <FormattedMessage
                    description="Layout weather/forecast/MountainWeather"
                    defaultMessage="Mountain Weather Forecast"
                />
            </a>
        </Link>
    )

    return (
        <Page>
            <Header title={title} />
            <Content>
                <Main>
                    <LoopProvider>{children}</LoopProvider>
                    <Footer />
                </Main>
                <Aside>
                    <Sidebar />
                </Aside>
            </Content>
        </Page>
    )
}

// Utils
function fetcher(locale) {
    return Weather.getForecast(new Date(), locale)
}
